import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useSupplyForwardingStatus, SupplyForwardingStatus } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<SupplyForwardingStatus>
    useData={useSupplyForwardingStatus}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
